import { render, staticRenderFns } from "./ProductPurchases.vue?vue&type=template&id=637b0401"
import script from "./ProductPurchases.vue?vue&type=script&lang=js"
export * from "./ProductPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports